<template>
    <div id="vehiclemodel_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div v-if="fuelDropVal != undefined">
            <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="fuelDropList"
                    mode="remote"
                    title="FuelDrops"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    @on-select-all="onSelectAll"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :search-options="{
                    enabled: false,
                    }">

                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'">
                                <router-link title="View Fuel Drop" v-if="canUpdateMod == true" class="fp-view mr-3" v-bind:to="{name: 'FuelDropView',params:{id:props.row.id}}"></router-link>
                                <router-link title="Edit Fuel Drop" v-if="canUpdateMod == true && props.row.status.toLowerCase() != 'processed'" class="fp-edit mr-3" v-bind:to="{name: 'FuelDropEdit',params:{id:props.row.id}}"></router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>

                    <!-- <div slot="selected-row-actions">
                        <button v-if="canDeleteMod && showProcessBtn" id="processVehicleModelBtn" v-on:click.prevent="fuelDropProcess" class="btn btn-success">Process</button>
                        <button v-if="canDeleteMod && showRemoveBtn" id="deleteVehicleModelBtn" v-on:click.prevent="fuelDropDelete" class="btn btn-primary">Delete</button>
                    </div> -->
                </vue-good-table>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Fuel Drop List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddMod" class="btn btn-primary pull-right" v-bind:to="{name: 'FuelDropCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content fuel-drop-list">
                        <data-table-filter-config :moduleName="'fuelDropList'" ref="filterFuelDrop" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'fuelDropList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="fuelDropList"
                                    mode="remote"
                                    title="FuelDrops"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: canDeleteMod,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="View Fuel Drop" v-if="canUpdateMod == true" class="fp-view mr-3" v-bind:to="{name: 'FuelDropView',params:{id:props.row.id}}"></router-link>
                                                <router-link title="Edit Fuel Drop" v-if="canUpdateMod == true && props.row.status.toLowerCase() != 'processed'" class="fp-edit mr-3" v-bind:to="{name: 'FuelDropEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="canDeleteMod && showProcessBtn" id="processVehicleModelBtn" v-on:click.prevent="fuelDropProcess" class="btn btn-success">Process</button>
                                        <button v-if="canDeleteMod && showRemoveBtn" id="deleteVehicleModelBtn" v-on:click.prevent="fuelDropDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div v-if="isCommonMsg">
                            <common-message :id="'common-message-modal'"></common-message>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";

import CommonMessage from "@/components/layout/CommonMessage.vue";
Vue.component("common-message", CommonMessage);
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "FuelDropList",
        metaInfo() {
            return this.fuelDropVal == undefined ? {title: "Fuel Drop List | " +process.env.COPYRIGHT_NAME} : {title: "FleetPro Application"}
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            fuelDropVal: {
                type: String,
                required: false,
                default: undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
               {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Tank No',
                //     field: 'tank_no',
                //     fpFieldType:"text",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Tank Number", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Item',
                    field: 'item',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Item", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Measurement Unit',
                    field: 'measurement_unit',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Measurement Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Quantity',
                    field: 'quantity',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Quantity", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Cost',
                    field: 'cost',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'User',
                    field: 'user',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date Time',
                    field: 'date_time',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Open","Received","Processed"]
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            canDeleteMod: false,
            loading:false,
            canAddMod:false,
            canUpdateMod:false,
            action:'list',
            pageKey:'_fuel_drop_list_',
            showProcessBtn:false,
            showRemoveBtn:false,
            isCommonMsg:false,
            commonName:'fuel_drop',
            commonMsg:'',
            commonErrorMsg:'',
            commonArr:[]
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_fuel_drop') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_fuel_drop') {
                            self.canDeleteMod = true;
                        }
                        if (permissions[i].name == 'add_fuel_drop') {
                            self.canAddMod = true;
                            self.canUpdateMod = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            if (self.fuelDropVal == undefined){
                self.getPermissions();
            }else{
                self.loadList();
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.fuelDropList.unselectAllInternal();
            },
            loadList() {
                var data = this.$refs['fuelDropList'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['fuelDropList'].selectedRows[i].id)
                }
                var from = '';
                var perPage = self.serverParams.perPage;
                if (self.fuelDropVal != undefined){
                    from = 'dashboard';
                    perPage = 10;
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use,
                    from:from
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-drop/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$refs.filterFuelDrop.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                            }else if (self.action == 'process'){
                                if (data.code == 201){
                                    self.$swal('',data.message,'info');
                                    return;
                                }
                                if (data.content.sub_system != undefined) {
                                    if (data.content.sub_system.length > 0) {
                                        self.isCommonMsg = true;
                                        self.commonErrorMsg = "Subsystem G/L TRANSACTION has been closed.";
                                        self.commonMsg = "Fuel Drop with following Tank No. cannot be processed : ";
                                        self.commonArr = data.content.sub_system;
                                    }else{
                                        self.isCommonMsg = false;
                                        self.commonErrorMsg = "";
                                        self.commonMsg = "";
                                        self.commonArr = [];
                                    }
                                }else{
                                    self.isCommonMsg = false;
                                    self.commonErrorMsg = "";
                                    self.commonMsg = "";
                                    self.commonArr = [];
                                }
                                self.action = 'list';
                                self.$refs.filterFuelDrop.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.action == 'delete'){
                            self.generateStatusCodeMessage(jqXHR,false,'load-fuel-drop-delete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'load-fuel-drop-list')
                        }

                    }
                });
            },
            fuelDropDelete() {
              var self = this;
              self.$swal({
                    title: 'Are you sure that you want to delete this Fuel Drop?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();
                    } else {
                      console.log("no");
                    }
                });

            },
             fuelDropProcess() {
                var data = this.$refs['fuelDropList'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['fuelDropList'].selectedRows[i].id)
                }
                if (confirm('Are you sure that you want to process this Fuel Drop? ')) {
                     self.action = 'process';
                     self.loadList();
                }

            },
            selectionChanged(param) {
                var self = this;

                var rowData = self.$refs['fuelDropList'].selectedRows;
                var selectedStatusArr = [];

                if(rowData.length > 0){
                    self.showProcessBtn = false;
                    self.showRemoveBtn = false;
                    for(var i = 0;i<rowData.length;i++){
                        selectedStatusArr.push(rowData[i].status.toLowerCase());
                    }
                    //check all values in array are equal or not
                    const allEqual = arr => arr.every( v => v === arr[0] );
                    var openFound = allEqual(selectedStatusArr);

                    if (openFound && selectedStatusArr.includes("received")) {
                        self.showProcessBtn = true;
                        self.showRemoveBtn = true;
                    }

                }
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/FuelDropList.vue